import { createFileRoute } from '@tanstack/react-router'

import { CompanyGlossaryScreen } from '@/features/glossary'
import { optional, z } from '@/lib/utils/search-params'

const glossarySearch = z.object({ q: optional(z.string().check(z.maxLength(200))) })

export const Route = createFileRoute('/_auth/admin/glossaries/$glossaryId')({
  validateSearch: glossarySearch,
  component: GlossaryRoute,
})

function GlossaryRoute() {
  const { glossaryId } = Route.useParams()
  const { q } = Route.useSearch()
  const navigate = Route.useNavigate()
  return (
    <CompanyGlossaryScreen
      glossaryId={glossaryId}
      q={q}
      onSearch={(next) => void navigate({ search: { q: next }, replace: true })}
      onDeleted={() => void navigate({ to: '/admin/glossaries', replace: true })}
    />
  )
}
